export default class TrackingEvent {
    #callback;
    #name;
    #timeout = null;
    constructor(options) {
        this.#callback = options.onTrigger;
        this.#name = options.name;
        if (options.timeout) {
            this.#timeout = setTimeout(() => {
                this.#sendBeacons(options.beaconUrls);
            }, options.timeout);
        }
        else {
            this.#sendBeacons(options.beaconUrls);
        }
    }
    destroy() {
        if (this.#timeout) {
            clearTimeout(this.#timeout);
            this.#timeout = null;
        }
    }
    #sendBeacons = async (urls) => {
        this.#callback?.(this.#name);
        urls?.forEach((url) => this.#sendBeacon(url));
    };
    #sendBeacon = async (url) => {
        try {
            fetch(url, {
                mode: 'no-cors',
            });
        }
        catch {
        }
    };
}
